module.exports = __webpack_public_path__ + "static/icon-cloudenable-6fef0733064dffded64a78c2a93a4810.svg";